<template>
  <section class="section --dark --centered --top">
    <div class="h-pad section__relative" v-reveal>
      <h2 class="title --uppercase">{{ content.title }}</h2>
			<HighlightableText class="description" :text="content.description" />
    </div>
    <div class="content-card__borders" v-reveal>
      <div class="content-card__container" ref="container">
        <div class="content-card__list">
          <ContentCard v-for="card in content.items" :key="card.flexKey" :content="card"/>
        </div>
      </div>
    </div>
    <ButtonControls v-if="content.items?.length > (mq.sm ? 1 : 3)" :max="content.items.length - (mq.sm ? 1 : 3)" :current="position"
                    class="content-card__controls" @increase="position += 1" @decrease="position -= 1"/>
  </section>
</template>

<script>
import {ButtonControls, HighlightableText} from '@/components/blocks'
import {ContentCard} from '@/components/cards'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'ContentCardsSection',
  inject: ['mq'],
  mixins: [HasContentMixin],
  components: {ButtonControls, ContentCard, HighlightableText},
  data() {
    return {
      position: 0
    }
  },
  watch: {
    'position'() {
      this.$refs.container.scrollTo({
        behavior: 'smooth',
        left: this.$refs.container.children[0].children[0].offsetWidth * this.position
      })
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.position = 0
    }, {passive: true})
  }
}
</script>